/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IInspectionRoute } from "../../model/inspection-route.model";
import { IPlant } from "../../model/plant.model";

import { TreeNodeRoute } from "../../components/InspectionRouteTree/types/treeNode";
import { IInspectionRouteGroup } from "../../model/inspection-route-group.model";

import dayjs from "dayjs";

import axios from "axios";
import { inspectionRouteAdapter } from "pages/thermography/InspectionRoute/adapters/inspectionRouteAdapter";
import { backendGroupsToTreeNodes } from "pages/thermography/components/InspectionRouteTree/mappers/genericTreeMapper";
import { syncNodesToGroups } from "../utils/functionsTreeNode";

export interface InspectionRouteState {
    data: IInspectionRoute | null;
    nodes: TreeNodeRoute[];
    groups: IInspectionRouteGroup[];
    loading: boolean;
    error: string | null;
    allRoutes: IInspectionRoute[];
}

const emptyRoute: IInspectionRoute = {
    id: undefined,
    code: "",
    name: "",
    description: "",
    maintenancePlan: "",
    periodicity: undefined,
    duration: 1,
    expectedStartDate: "",
    createdAt: dayjs().toISOString(),

    plant: undefined,

    createdBy: {
        id: "user-001",
        position: "Engenheiro de Manutenção",
        phoneNumber: "+55 21 99999-1111",
    },

    groups: [],
};

const initialState: InspectionRouteState = {
    data: emptyRoute,
    nodes: [],
    groups: [],
    loading: false,
    error: null,
    allRoutes: []
};


export const fetchRoute = createAsyncThunk(
    "inspectionRoute/fetchRoute",
    async (id: string, thunkAPI) => {
        try {
            const res = await axios.get(`/api/inspection-routes/actions/${id}`);
            return res.data as IInspectionRoute;
        } catch (err) {
            return thunkAPI.rejectWithValue("Erro ao carregar rota");
        }
    }
);

export const fetchAllRoutes = createAsyncThunk(
    "inspectionRoute/fetchAllRoutes",
    async (_, thunkAPI) => {
        try {
            const res = await axios.get("/api/inspection-routes");
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue("Erro ao carregar rotas");
        }
    }
);

export const createRoute = createAsyncThunk(
    "inspectionRoute/createRoute",
    async (_, thunkAPI) => {
        const state = thunkAPI.getState() as any;
        const { data: route, nodes } = state.inspectionRoute;

        if (!route) return thunkAPI.rejectWithValue("Rota inválida");

        try {
            const groups = syncNodesToGroups(state.inspectionRoute);
            let newRoute = { ...route };
            newRoute.groups = groups;

            const payload = newRoute;
            const res = await axios.post(`/api/inspection-routes/actions/create-route`, payload);

            return res.data;

        } catch (err) {
            console.error("Erro no createRoute", err);
            return thunkAPI.rejectWithValue("Erro ao criar rota");
        }
    }
);

export const updateRoute = createAsyncThunk(
    "inspectionRoute/updateRoute",
    async (_, thunkAPI) => {
        const state = thunkAPI.getState() as any;
        const { data: route, nodes } = state.inspectionRoute;

        if (!route || !route.id)
            return thunkAPI.rejectWithValue("Rota inválida");

        try {
            const groups = syncNodesToGroups(state.inspectionRoute);

            let newRoute = { ...route };
            newRoute.groups = groups;

            const payload = newRoute;
            const res = await axios.put(`/api/inspection-routes/actions/update-route/${route.id}`, payload);

            return res.data as IInspectionRoute;
        } catch (err) {
            return thunkAPI.rejectWithValue("Erro ao atualizar rota");
        }
    }
);

export const getNewRoute = createAsyncThunk(
    "inspectionRoute/getNewRoute",
    async (plantId: String | undefined, thunkAPI) => {
        try {
            const token = localStorage.getItem("jhi-authenticationToken");

            const res = await axios.get(`/api/inspection-routes/new/${plantId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json"
                }
            });

            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue("Erro ao carregar árvore padrão");
        }
    }
);

export const deleteRoute = createAsyncThunk(
    "inspectionRoute/deleteRoute",
    async (routeId: string, thunkAPI) => {
        try {
            await axios.delete(`/api/inspection-routes/actions/delete-route/${routeId}`);
            return routeId; // retorna só o ID
        } catch (err) {
            return thunkAPI.rejectWithValue("Erro ao excluir rota");
        }
    }
);

const inspectionRouteSlice = createSlice({
    name: "inspectionRoute",
    initialState,
    reducers: {
        setPlant(state, action: PayloadAction<IPlant | undefined>) {
            if (state.data) state.data.plant = action.payload;
        },
        setName(state, action: PayloadAction<string>) {
            if (state.data) state.data.name = action.payload;
        },
        setMaintenancePlan(state, action: PayloadAction<string>) {
            if (state.data) state.data.maintenancePlan = action.payload;
        },
        setPeriodicity(state, action: PayloadAction<string>) {
            if (state.data) state.data.periodicity = action.payload as any;
        },
        setDuration(state, action: PayloadAction<number>) {
            if (state.data) state.data.duration = action.payload;
        },
        setExpectedStartDate(state, action: PayloadAction<string | null>) {
            if (state.data)
                state.data.expectedStartDate = action.payload ?? "";
        },
        setDescription(state, action: PayloadAction<string>) {
            if (state.data) state.data.description = action.payload;
        },

        setNodes(state, action: PayloadAction<TreeNodeRoute[]>) {
            state.nodes = action.payload;
        },

        resetRoute(state) {
            state.data = { ...emptyRoute };
            state.data.createdAt = dayjs().toISOString();
            state.nodes = [];
            state.groups = [];
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchRoute.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchRoute.fulfilled, (state, action) => {
                state.loading = false;

                const route = action.payload;

                state.data = route;
                state.groups = route.groups ?? [];

                state.nodes = backendGroupsToTreeNodes(route.groups, inspectionRouteAdapter);

                state.error = null;
            })
            .addCase(fetchRoute.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            .addCase(createRoute.pending, (state) => {
                state.loading = true;
            })
            .addCase(createRoute.fulfilled, (state, action) => {
                state.loading = false;

                state.data = action.payload;
                state.groups = action.payload.groups ?? [];
                state.nodes = backendGroupsToTreeNodes(state.groups, inspectionRouteAdapter);

                if (!state.allRoutes) state.allRoutes = [];
                state.allRoutes.push(action.payload);
            })
            .addCase(createRoute.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            .addCase(updateRoute.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateRoute.fulfilled, (state, action) => {
                state.loading = false;

                const updated = action.payload;

                state.data = updated;
                state.groups = updated.groups ?? [];

                state.nodes = backendGroupsToTreeNodes(state.groups, inspectionRouteAdapter);

                if (state.allRoutes) {
                    const index = state.allRoutes.findIndex(r => r.id === updated.id);
                    if (index !== -1) {
                        state.allRoutes[index] = updated;
                    }
                }
            })
            .addCase(updateRoute.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(getNewRoute.fulfilled, (state, action) => {
                state.loading = false;

                const route = action.payload;
                const groups = route.groups ?? [];

                state.data = route;
                state.groups = groups;

                state.nodes = backendGroupsToTreeNodes(route.groups, inspectionRouteAdapter);

                state.error = null;
            })
            .addCase(getNewRoute.pending, (state) => {
                state.loading = true;
            })
            .addCase(getNewRoute.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(fetchAllRoutes.fulfilled, (state, action) => {
                state.allRoutes = action.payload;
            })
            .addCase(deleteRoute.fulfilled, (state, action) => {
                const deletedId = action.payload;

                if (state.allRoutes) {
                    state.allRoutes = state.allRoutes.filter(r => r.id !== deletedId);
                }

                if (state.data?.id === deletedId) {
                    state.data = null;
                    state.nodes = [];
                    state.groups = [];
                }

                state.loading = false;
            })
    },
});

export const {
    setPlant,
    setName,
    setMaintenancePlan,
    setPeriodicity,
    setDuration,
    setExpectedStartDate,
    setDescription,
    setNodes,
    resetRoute,
} = inspectionRouteSlice.actions;

export default inspectionRouteSlice.reducer;